import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-eula-step',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule, TranslateModule, LoadingSpinnerComponent],
  host: { class: 'flex-1 flex flex-col min-h-0' },
  template: `
    <div class="flex flex-col flex-1 min-h-0">
      <h2 class="headline-medium text-primary mb-4 hidden md:block shrink-0" style="font-family: 'DM Sans', sans-serif">{{ 'EULA' | translate }}</h2>

      <div class="flex-1 overflow-auto mb-6 text-on-surface-variant body-medium leading-relaxed min-h-0">
        @if (!iframeReady()) {
          <div class="flex items-center justify-center h-full">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
        }
        <iframe
          [src]="eulaUrl"
          class="w-full h-full border-0 min-h-[400px]"
          [style.display]="iframeReady() ? 'block' : 'none'"
          (load)="onIframeLoad()"
          sandbox="allow-same-origin"
        ></iframe>
      </div>

      <div class="flex items-center justify-between gap-4 pt-4 shrink-0">
        <div class="hidden md:block w-1/2">
          <button mat-stroked-button type="button" class="w-full" (click)="goBack.emit()">
            {{ 'Go back' | translate }}
          </button>
        </div>

        <button
          mat-flat-button
          color="primary"
          class="flex-1"
          [disabled]="!iframeReady() || loading"
          (click)="accept.emit()"
        >
          <app-loading-spinner [loading]="loading" [diameter]="20">
            {{ 'Accept' | translate }}
          </app-loading-spinner>
        </button>
      </div>
    </div>
  `,
})
export class EulaStepComponent {
  @Output() accept = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();

  @Input() loading = false;
  iframeReady = signal(false);
  eulaUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.eulaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.eulaUrl);
  }

  onIframeLoad(): void {
    this.iframeReady.set(true);
  }
}
